import { useEffect, useState } from 'react'
import { getUnseenChats } from '../Api/Chats/Chats'
import { useSocket } from '../../../hooks/useSocket';
import { useAdminInfo } from '../../../hooks/useAdminInfo';

export const useUnseenChats = () => {
    const { socket } = useSocket();
    const { adminInfo } = useAdminInfo();

    const [unseenChats, setUnseenChats] = useState<number>(0)
    const [unseenAnnonChats, setUnseenAnnonChats] = useState<number>(0)
    const fetchUnseenChats = async () => {
        const unseenChats = await getUnseenChats()
        setUnseenChats(unseenChats?.unseenChatsCount ?? 0)
        setUnseenAnnonChats(unseenChats?.unseenAnnonChatsCount ?? 0)
    }

    useEffect(() => {
        fetchUnseenChats()
    }, [])


    useEffect(() => {
        if (socket && adminInfo) {
            socket.on(`update-chats-${adminInfo?.id}`, () => {
                fetchUnseenChats()
            });
            socket.on(`update-anon-chats-${adminInfo?.id}`, () => {
                fetchUnseenChats()
            });
            socket.on(`update-seen-tag-${adminInfo?.id}`, () => {
                fetchUnseenChats()
            });
        }

        return () => {
            if (socket) {
                socket.off(`update-chats-${adminInfo?.id}`)
                socket.off(`update-anon-chats-${adminInfo?.id}`)
                socket.off(`update-seen-tag-${adminInfo?.id}`)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [socket, adminInfo]);

    return {
        unseenChats,
        unseenAnnonChats,
        setUnseenChats,
        setUnseenAnnonChats
    }
}
